// src/features/appStructure/useAppStructure.ts
import { useQuery } from "@tanstack/react-query"
import { appStructureQueryOptions } from "./queries"

export function useAppStructure() {
	return useQuery(appStructureQueryOptions())
}
